const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen pt-24 px-4 bg-[#0A0A0A]">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold font-['Space_Grotesk'] text-[#F4F1DE] mb-8">
          Terms of Service
        </h1>
        
        <div className="bg-[#121212] border border-white/10 p-8 space-y-8">
          <p className="text-[#F4F1DE]/60 text-sm">
            Last updated: December 2025
          </p>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">1. Agreement to Terms</h2>
            <p className="text-[#F4F1DE]/80 leading-relaxed">
              By accessing or using ReptiCraft's website and services, you agree to be bound by these 
              Terms of Service. If you do not agree with any part of these terms, you may not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">2. Products & Ordering</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p><strong className="text-[#F4F1DE]">Custom Products:</strong> All enclosures are made to order based on your specifications. Please review your configuration carefully before placing an order.</p>
              <p><strong className="text-[#F4F1DE]">Pricing:</strong> All prices are displayed in GBP (£) and include VAT where applicable. Prices may change without notice, but confirmed orders will be honored at the quoted price.</p>
              <p><strong className="text-[#F4F1DE]">Order Confirmation:</strong> An order is confirmed only when payment is successfully processed. You will receive an email confirmation with your order details.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">3. Payment</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p>We accept payment via credit/debit card through Stripe. All payments are processed securely and we do not store your full card details.</p>
              <p>Payment is required in full before production begins on your enclosure.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">4. Delivery</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p><strong className="text-[#F4F1DE]">Delivery Times:</strong></p>
              <ul className="list-disc pl-6 space-y-2">
                <li>UK: 5-10 working days from dispatch</li>
                <li>EU Zone 1 (Ireland, France, Germany, etc.): 7-12 working days</li>
                <li>EU Zone 2 (Italy, Spain, Poland, etc.): 10-15 working days</li>
                <li>EU Zone 3 (Sweden, Finland, Greece, etc.): 12-18 working days</li>
              </ul>
              <p><strong className="text-[#F4F1DE]">Production Time:</strong> Please allow 2-4 weeks for production before dispatch, depending on complexity.</p>
              <p><strong className="text-[#F4F1DE]">Shipping Costs:</strong> Shipping costs are calculated at checkout based on your location and order size.</p>
              <p><strong className="text-[#F4F1DE]">Risk of Loss:</strong> Risk passes to you upon delivery. Please inspect your enclosure immediately upon receipt.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">5. Cancellations & Changes</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p><strong className="text-[#F4F1DE]">Before Production:</strong> Orders can be cancelled or modified within 48 hours of placement. Contact us immediately at repticraftstore@gmail.com.</p>
              <p><strong className="text-[#F4F1DE]">During Production:</strong> Once production has begun, orders cannot be cancelled. Changes may be possible at additional cost — please contact us to discuss.</p>
              <p><strong className="text-[#F4F1DE]">Refunds:</strong> Approved cancellations will be refunded within 5-10 business days. Refunds are processed to the original payment method.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">6. Returns & Warranty</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p><strong className="text-[#F4F1DE]">Custom Products:</strong> As all products are made to your specifications, we cannot accept returns for change of mind.</p>
              <p><strong className="text-[#F4F1DE]">Damaged Goods:</strong> If your enclosure arrives damaged, please photograph the damage and contact us within 48 hours of delivery. We will arrange repair or replacement at no additional cost.</p>
              <p><strong className="text-[#F4F1DE]">Warranty:</strong> We offer a 12-month warranty against manufacturing defects. This does not cover:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Normal wear and tear</li>
                <li>Damage from misuse or improper assembly</li>
                <li>Damage from environmental factors (excessive moisture, heat, etc.)</li>
                <li>Modifications made after delivery</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">7. EU Consumer Rights</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p>If you are an EU consumer, you have additional rights under EU consumer protection laws. For custom-made products, the standard 14-day cooling-off period does not apply (as per Article 16(c) of the Consumer Rights Directive).</p>
              <p>Your statutory rights regarding faulty goods are not affected by these terms.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">8. User Accounts</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p>You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use of your account.</p>
              <p>We reserve the right to suspend or terminate accounts that violate these terms.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">9. Intellectual Property</h2>
            <p className="text-[#F4F1DE]/80 leading-relaxed">
              All content on this website, including text, images, logos, and designs, is owned by ReptiCraft 
              and protected by copyright laws. You may not reproduce, distribute, or create derivative works 
              without our written permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">10. Limitation of Liability</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p>To the maximum extent permitted by law:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Our liability is limited to the purchase price of the product</li>
                <li>We are not liable for indirect, incidental, or consequential damages</li>
                <li>We are not liable for harm to animals — always ensure proper setup and monitoring</li>
              </ul>
              <p>Nothing in these terms excludes liability for death, personal injury, or fraud.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">11. Governing Law</h2>
            <p className="text-[#F4F1DE]/80 leading-relaxed">
              These terms are governed by English law. Any disputes will be subject to the exclusive 
              jurisdiction of the courts of England and Wales. EU consumers may also bring proceedings 
              in their local courts.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">12. Changes to Terms</h2>
            <p className="text-[#F4F1DE]/80 leading-relaxed">
              We may update these terms from time to time. The updated version will be posted on this 
              page with a new "Last updated" date. Continued use of our services after changes 
              constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">13. Contact</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed">
              <p>For questions about these terms, contact us at:</p>
              <p className="mt-4">
                <strong className="text-[#F4F1DE]">Email:</strong>{" "}
                <a href="mailto:repticraftstore@gmail.com" className="text-[#E07A5F] hover:underline">
                  repticraftstore@gmail.com
                </a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
